import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { modal } from 'react-redux-modal';
import fetch from 'isomorphic-fetch';
import * as m3u8Parser from 'm3u8-parser';
import { checkHttpStatus, imageFromSetByDimension, parseText } from '../../utils';
import { CamInfoModalView, ImageDetails } from '../index';

class RelatedSnapshot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSnapshot: null,
    };

    this.thumbnailUpdater = null;
    this.getLatestThumbnail = this.getLatestThumbnail.bind(this);
  }
  componentWillMount() {
    const { isVisible, hlsInfo } = this.props;
    if (isVisible && !_.isEmpty(hlsInfo)) {
      this.getLatestThumbnail();
    }
  }

  componentWillUnmount() {
    clearInterval(this.thumbnailUpdater);
    this.thumbnailUpdater = false;
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // Update interval refresh rate
    const { isVisible, hlsInfo = {} } = nextProps;
    if (!isVisible || _.isEmpty(hlsInfo)) {
      clearInterval(this.thumbnailUpdater);
      this.thumbnailUpdater = null;
      return;
    }

    if (isVisible && !this.thumbnailUpdater) {
      if (this.thumbnailUpdater) {
        clearInterval(this.thumbnailUpdater);
      }
      this.getLatestThumbnail();
      this.thumbnailUpdater = setInterval(this.getLatestThumbnail, 3000);
    }
  }

  getLatestThumbnail() {
    const { hlsInfo } = this.props;
    if (_.isEmpty(hlsInfo)) return;

    fetch(hlsInfo.playlistUrl)
      .then(checkHttpStatus)
      .then(parseText)
      .then((manifest) => {
        const { hlsInfo: streamData } = this.props;
        const parser = new m3u8Parser.Parser();

        parser.push(manifest);
        parser.end();

        const parsedManifest = parser.manifest;

        if (parsedManifest.segments.length > 0) {
          const firstSegment = parsedManifest.segments[0];
          const parsedUrl = new URL(streamData.playlistUrl.replace('.m3u8', firstSegment.uri));

          if (streamData) {
            const { snapshotHost } = streamData;
            parsedUrl.hostname = snapshotHost;

            const currentSnapshot = `${parsedUrl.href}.thumbnail.jpg`;
            this.setState({ currentSnapshot });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showInfo(e, relatedSnapshot) {
    e.preventDefault();

    modal.add(CamInfoModalView, {
      title: '',
      size: 'medium',
      hideTitleBar: true,
      id: 'signup',
      item: relatedSnapshot,
    });
  }

  render() {
    const { relatedSnapshot, isActive, hlsInfo, onThumbnailClick, isVisible, camGroupSlug} = this.props;
    const { currentSnapshot } = this.state;
    const primaryFeed = isActive ? ' active ' : '';

    let snapshotText = '';
    if (isActive) {
      snapshotText = 'now watching';
    } else {
      snapshotText = (relatedSnapshot.title || relatedSnapshot.h2_title);
    }

    let currentViewerCount = relatedSnapshot.current_viewers;
    let currentViewers = (relatedSnapshot.current_viewers === 0 || !relatedSnapshot.current_viewers) ? ' no-viewers ' : '';
    const fallbackImage = _.has(relatedSnapshot, 'stillframe_imageset.width')
      ? imageFromSetByDimension(250, relatedSnapshot.stillframe_imageset.width)
      : relatedSnapshot.thumbnail_large_url;

    let snapshotSrc = '';
    if (!relatedSnapshot.stream_id) {
      snapshotSrc = fallbackImage;
      snapshotSrc = snapshotSrc.replace('http://', 'https://');
    } else {
      snapshotSrc = currentSnapshot || fallbackImage;
    }

    let statusClass = '';
    let stateFromStream = false;
    if (relatedSnapshot.stream_id) {
      const streamInfo = hlsInfo;
      currentViewerCount = streamInfo.numberOfViewers;
      if (currentViewerCount === 0) {
        currentViewers = ' no-viewers';
      }

      if (streamInfo && Object.keys(streamInfo).length > 0) {
        const { offline_label: offlineLabel } = relatedSnapshot;
        try {
          if (streamInfo.state === 'live') {
            statusClass = 'is-online';
            stateFromStream = true;
          } else if (offlineLabel) {
            switch (offlineLabel) {
              case 'Meditation':
                statusClass = 'is-meditation';
                break;
              case 'Film':
                statusClass = 'is-film';
                break;
              case 'Highlights':
                statusClass = 'is-offline';
                break;
              case 'Off Season':
                statusClass = 'is-off-season';
                break;
              default:
                statusClass = '';
            }
            stateFromStream = true;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
    if (!stateFromStream) {
      if (!relatedSnapshot.is_inactive) {
        statusClass = ' is-online ';
      } else {
        const { offline_label: offlineLabel } = relatedSnapshot;

        if (offlineLabel) {
          switch (offlineLabel) {
            case 'Meditation':
              statusClass = 'is-meditation';
              break;
            case 'Film':
              statusClass = 'is-film';
              break;
            case 'Highlights':
              statusClass = 'is-offline';
              break;
            case 'Off Season':
              statusClass = 'is-off-season';
              break;
            default:
              statusClass = 'is-offline';
          }
        }
      }
    }

    const isVisibleClass = isVisible ? 'is-visible' : '';
    let isActiveClass = isActive ? 'now-watching' : '';
    if (!isActive) {
      isActiveClass = (relatedSnapshot.is_inactive) ? 'is-offline' : 'not-watching';
    }

    return (
      <div
        className={`cam-container related-snapshot-item ${statusClass} ${primaryFeed} ${currentViewers} ${isVisibleClass}`}
      >
        <ImageDetails
          className="cam-item"
          isActive={isActive}
          imgSrc={snapshotSrc}
          to={`/livecams/${camGroupSlug}/${relatedSnapshot.slug}`}
          camId={relatedSnapshot.id}
          fallbackImgSrc={fallbackImage}
          onHandleClick={e => onThumbnailClick(relatedSnapshot, e)}
          imgWidth={null}
          imgHeight={null}
          feedImage
        >
          <div
            className={isActiveClass}
            data-default-title={(isActive) ? (relatedSnapshot.title || relatedSnapshot.h2_title) : ''}
          >
            <span
              className={(isActive) ? 'text-uppercase u-textSize-18' : 'u-font-foundation-roman u-textSize-18'}
            >
              {snapshotText}
            </span>
            {
              currentViewerCount > 0 &&
              <div className="cam-item-separator" />
            }
          </div>
          {
            currentViewerCount > 0 &&
            <div className="viewer-count">
              <div className="text-uppercase u-font-foundation-light u-textSize-16">
                {currentViewerCount} viewers
              </div>
            </div>
          }
          <div className="d-none d-sm-flex align-items-center justify-content-center">
            <button
              className="info-btn text-uppercase u-textSize-14"
              onClick={(e) => {
                this.showInfo(e, relatedSnapshot);
              }}
            >
              information
            </button>
          </div>
        </ImageDetails>
      </div>
    );
  }
}

const propTypes = {
  isActive: PropTypes.bool,
  relatedSnapshot: PropTypes.object,
  hlsInfo: PropTypes.object,
  onThumbnailClick: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  camGroupSlug: PropTypes.string,
};

const defaultProps = {
  isActive: false,
  relatedSnapshot: {},
  hlsInfo: {},
  isVisible: false,
  camGroupSlug: '',
};

RelatedSnapshot.propTypes = propTypes;
RelatedSnapshot.defaultProps = defaultProps;

export default RelatedSnapshot;
